import { useEffect } from "react";
import Icon from "./Icon";

const ConfirmModal = ({
  show,
  title = "Are you sure?",
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  variant = "danger",
  onConfirm,
  onCancel,
}) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [show]);

  if (!show) return null;

  const btnClass =
    variant === "danger"
      ? "confirm-modal__btn--danger"
      : variant === "warning"
        ? "confirm-modal__btn--warning"
        : "confirm-modal__btn--primary";

  return (
    <div className="confirm-modal-overlay" onClick={onCancel}>
      <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-modal__icon-wrap">
          {variant === "danger" && (
            <Icon
              name="trash3"
              className="confirm-modal__icon confirm-modal__icon--danger"
            />
          )}
          {variant === "warning" && (
            <Icon
              name="exclamation-triangle"
              className="confirm-modal__icon confirm-modal__icon--warning"
            />
          )}
          {variant === "primary" && (
            <Icon
              name="question-circle"
              className="confirm-modal__icon confirm-modal__icon--primary"
            />
          )}
        </div>
        <h5 className="confirm-modal__title">{title}</h5>
        {message && <p className="confirm-modal__message">{message}</p>}
        <div className="confirm-modal__actions">
          <button
            className="confirm-modal__btn confirm-modal__btn--cancel"
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
          <button
            className={`confirm-modal__btn ${btnClass}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
